import modules_reports from './reports/index.js'
import modules_payment from './payment/index.js'
import modules_form from './form/index.js'
import modules_files from './files/index.js'
import _actions_save from './_actions/save.js'
import _actions_reload from './_actions/reload.js'
import _actions_get from './_actions/get.js'
import _actions_create from './_actions/create.js'
import _actions_clean from './_actions/clean.js'
import _actions_change from './_actions/change.js'
import _getters_title from './_getters/title.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        set: _mutations_set,
    },
    getters:{
        title: _getters_title,
    },
    actions:{
        change: _actions_change,
        clean: _actions_clean,
        create: _actions_create,
        get: _actions_get,
        reload: _actions_reload,
        save: _actions_save,
    },
    modules:{
        files: modules_files,
        form: modules_form,
        payment: modules_payment,
        reports: modules_reports,
    },
}